import React, { useState, ReactNode } from "react"
import ReactCopyToClipboard from "react-copy-to-clipboard"
import Button from "components/Buttons/Button"

type Props = {
  children: ReactNode | ReactNode[];
  text: string;
  copiedContent?: ReactNode;
  [x: string]: any;
}

const CopyToClipboard = ({
  children, text, copiedContent = "Copied!", ...props
}: Props) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 5000)
  }

  return (
    <ReactCopyToClipboard text={text} onCopy={() => handleCopy()}>
      <Button {...props}>
        {copied ? copiedContent : children}
      </Button>
    </ReactCopyToClipboard>
  )
}

export default CopyToClipboard
